import React from "react";
import loadable from "@loadable/component";

export const AboutOperator = loadable(() => import("./aboutOperator"));
export const RatesMobile = loadable(() => import("./ratesMobile"));
export const SimCards = loadable(() => import("./simCards"));
export const BeautifulNumbers = loadable(() => import("./beautifulNumbers"));
export const Actions = loadable(() => import("./actions"));
